<ng-container *ngIf="action.text">
    <a *ngIf="action.internalLink" [routerLink]="action.internalLink" mat-stroked-button color="accent">{{action.text}}</a>
    <a *ngIf="action.externalLink" [href]="action.externalLink" mat-stroked-button color="accent">{{action.text}}</a>
    <a *ngIf="action.downloadLink" [href]="action.downloadLink" mat-stroked-button color="accent" target="_blank" >{{action.text}}</a>
    <ng-container *ngIf="!(action.externalLink || action.internalLink || action.downloadLink)">
        <button *ngIf="!action.externalLink" mat-stroked-button color="accent" (click)="onClickFn()">{{action.text}}</button>
    </ng-container>
</ng-container>